    <div class="modal-content"style="padding: 0px;">
        <div class="col-md-12 col-lg-12 col-12" style="padding: 15px; padding-bottom: 0px;">
            <div class="col-md-9 col-lg-9 col-9" style="padding: 0px; display: inline-block;">
                <h4 style="padding-right: 15px; display: inline-block;font-size: 1.4rem;">Quantity Calculator</h4>
            </div>
            <div class="col-md-3 col-lg-3 col-3" style="padding: 0px; display: inline-block; text-align: right;">
                <i class="closeMdl zmdi zmdi-close webView" style="padding: 7px 11px !important; position: relative; bottom: 10px; margin-top: 0px; top: -6px;" (click)="closeModal()"></i>
            </div>
        </div>
        <div class="modal-body" style="padding: 0px 15px;">       
            <div class="col-md-12 col-sm-12 col-xs-12 pad0">
                
                <div class="col-md-12 col-sm-12 col-xs-12 pad0"style="margin-top: 10px; margin-bottom: 10px;">                  
                    <span style="font-size: 13px;">1 {{invoiceUnit}} =</span>
                    <input type="text" [(ngModel)]="unitCount" (keypress)="numberOnly($event)" (keyup)="pricisionCheck();" style="text-align: right;" class="form-control unitboxsize"/>
                    <span style="font-size:13px;">{{itemUnit}}</span>
                </div>
                <div *ngIf="(unitCount * invQty) > 0" class="orangeBadge disblk mrgRgt10 font13" style="display: inline-block; margin-top: 10px; cursor: pointer; border: 1px solid #e88421 !important;">
                    {{invQty}} {{invoiceUnit}} = {{unitCount * invQty}} {{itemUnit}} </div>
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="position: relative; display: inline-block; margin-top: 10px; margin-bottom: 15px;">
                    <span (click)="calculateUnit()" class="btn-green" style="padding: 0px 10px;line-height: 30px;font-size: 14px;"> <i class="fa fa-check" style="margin-right: 5px;" aria-hidden="true"></i>Save </span>                   
                </div>
            </div>
        </div>
    </div>

